var map = {
	"./img/loading.gif": 517,
	"./img/logo-light.png": 65,
	"./img/logo-light.svg": 63,
	"./img/logo-primary.svg": 170,
	"./img/logo.png": 549,
	"./img/logo.svg": 503,
	"./img/portfolio/agenchy-thumbnail.jpg": 637,
	"./img/portfolio/organature-thumbnail.jpg": 694,
	"./img/portfolio/stoneworks-thumbnail.jpg": 783,
	"./img/portfolio/tradingblock-thumbnail.jpg": 770,
	"./img/portfolio/universh-thumbnail.jpg": 96,
	"./scss/App.scss": 444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;